<div class="loading-overlay" *ngIf="loadingState.isLoading">
  <div class="loading-container">
    <div class="loading-spinner">
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
    </div>
    <div class="loading-text">
      <p>{{ loadingState.message || 'Loading...' }}</p>
      <p class="loading-subtext">Please wait while we process your request</p>
      <p class="loading-counter" *ngIf="isAdminRoute && loadingState.activeRequests > 1">
        {{ loadingState.activeRequests }} active requests
      </p>
    </div>
  </div>
</div>